import React from 'react';
import Input from '../Input';
import './_select.scss';

const Select = ({ type, ...restProps }) => (
  <Input type="select" {...restProps} />
);

export default Select;
